import req from "../http";

const incomeTax = {
  // 是否需要填寫 免稅額申報表
  getRequiredIncomeTaxReturn(matchId) {
    return req("get", `/Recruitment/IncomeTaxReturn/Required/${matchId}`);
  },

  // 取得 免稅額申報表
  getIncomeTaxReturn(matchId) {
    return req("get", `/Recruitment/IncomeTaxReturn/${matchId}`);
  },

  // 儲存 免稅額申報表
  putIncomeTaxReturn(params) {
    return req("put", "/Recruitment/IncomeTaxReturn", params);
  },

  // 下載 免稅額申報表 PDF
  downloadIncomeTaxReturnPDF(params) {
    return req("post", "/Recruitment/IncomeTaxReturn/PDF", params, { responseType: "blob" });
  },
};

export default incomeTax;